import { AccomodationEnum } from '../../enums/accomodation-type/accomodation-type'
import { CenterCompact, CenterLight, CenterMinimal } from '../center/center'
import { CenterGroupBasic } from '../center-group/center-group'
import { EnrollmentLight } from '../enrollment/enrollment-light'
import { HostFamilyLight } from '../host-family/host-family'
import { HostFamilyHistory } from '../host-family-history/host-family-history'

export enum EnrollmentDiffusionStateEnum {
  UNKNOWN = 'UNKNOWN', // Unknown
  EXISTING = 'EXISTING', // Existing
  DELETED = 'DELETED' // Deleted
}

export interface EnrollmentCenter {
  id: number
  center: CenterLight
  hostFamilyHistory: HostFamilyHistory[]
  enrollment: EnrollmentLight
  enrollmentId: number
  hostFamily?: HostFamilyLight
  hostFamilyDiffused: boolean
  hostFamilyDiffusedAt?: Date
  centerGroup?: CenterGroupBasic

  informationSharedToHFByEmail: boolean

  diffusionState: EnrollmentDiffusionStateEnum
  diffused: boolean
  diffusedAt?: Date

  deleted: boolean
  viewedByOl: boolean
}

export interface EnrollmentCenterCompact extends Pick<EnrollmentCenter, 'id' | 'hostFamily'> {
  center: CenterCompact
}

export interface EnrollmentCenterIdOnly {
  id: number
}

export interface EnrollmentCenterFilters {
  centerId?: number
  mainTripId?: number
  centerAccomodations?: AccomodationEnum[]
  hasHostFamily?: boolean
  hasAffectedStaff?: boolean
  excludedIds?: number[]
}

export type EnrollmentCenterCenterDetails = Pick<EnrollmentCenter, 'id'> & {
  center: CenterMinimal
}

export type EnrollmentCenterCenterInfo = Pick<
  EnrollmentCenter,
  'id' | 'deleted' | 'hostFamily' | 'center'
>
